module.exports = __webpack_public_path__ + "static/media/garde coordinator.2a307bff.svg";